// extracted by mini-css-extract-plugin
export var videoWrapper = "VideoPlayer-module--videoWrapper--3_E5R";
export var videoPlayer = "VideoPlayer-module--videoPlayer--2XU_g";